export const loadsSourcingPageStateKey = 'loads-sourcing-page';
import { CarrierDTOResponse } from 'cargo-chief-commons';

export interface LoadsSourcingState {
	accountId: number;
	accountLogoUrl: string;
	businessName: string;
	carrier: CarrierDTOResponse;
	carrierId: string;
	carrierMc: string;
	carrierDot: string;
	currentPage: number;
	error: string;
	filters: any[];
	loading: boolean;
	loadsList: any[];
	successfulLoads: any[];
	unsuccessfulLoads: any[];
	currentRateSelection: number;
	offerSubmitted: boolean;
	offerDialogOpen: boolean;
	pageSize: number;
	sort: any[];
	total: number;
}

export const initialState: LoadsSourcingState = {
	accountId: null,
	accountLogoUrl: null,
	businessName: null,
	carrier: null,
	carrierId: null,
	carrierMc: null,
	carrierDot: null,
	currentPage: 0,
	error: null,
	filters: [],
	loading: true,
	loadsList: [],
	successfulLoads: [],
	unsuccessfulLoads: [],
	currentRateSelection: null,
	offerSubmitted: false,
	offerDialogOpen: false,
	pageSize: 25,
	sort: [],
	total: 0,
};
